import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CustomerOverviewPage } from './customer-overview';

@NgModule({
  declarations: [
    CustomerOverviewPage,
  ],
  imports: [
    IonicPageModule.forChild(CustomerOverviewPage),
  ],
})
export class CustomerOverviewPageModule {}



// WEBPACK FOOTER //
// ./src/pages/customer-overview/customer-overview.module.ts